import React from 'react';

const Checkbox = ({ color = 'black', className, onClick, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9129 0.500001H8.08705C6.37752 0.499978 5.02343 0.499966 3.9637 0.675018C2.87308 0.855155 1.99034 1.23472 1.29418 2.08999C0.598028 2.94527 0.289079 4.02978 0.142456 5.36969C-2.75373e-05 6.67165 -1.81831e-05 8.3352 4.21586e-07 10.4355V10.5645C-1.81831e-05 12.6648 -2.75373e-05 14.3283 0.142456 15.6303C0.289079 16.9702 0.598028 18.0547 1.29418 18.9101C1.99034 19.7653 2.87308 20.1448 3.9637 20.325C5.02342 20.5 6.37749 20.5 8.08701 20.5H11.9129C13.6225 20.5 14.9766 20.5 16.0363 20.325C17.1269 20.1448 18.0097 19.7653 18.7059 18.9101C19.402 18.0547 19.7109 16.9702 19.8576 15.6303C20 14.3283 20 12.6648 20 10.5646V10.4355C20 8.33531 20 6.67164 19.8576 5.36969C19.7109 4.02978 19.402 2.94527 18.7059 2.08999C18.0097 1.23472 17.1269 0.855155 16.0363 0.675018C14.9766 0.499966 13.6225 0.499978 11.9129 0.500001ZM2.28084 3.30217C2.67452 2.8185 3.21373 2.52859 4.14963 2.37401C5.10559 2.2161 6.36575 2.21429 8.13953 2.21429H11.8605C13.6342 2.21429 14.8944 2.2161 15.8504 2.37401C16.7862 2.52859 17.3255 2.8185 17.7192 3.30217C18.1128 3.78584 18.3488 4.4483 18.4746 5.59811C18.6032 6.77258 18.6047 8.3208 18.6047 10.5C18.6047 12.6792 18.6032 14.2274 18.4746 15.4019C18.3488 16.5517 18.1128 17.2142 17.7192 17.6978C17.3255 18.1815 16.7862 18.4714 15.8504 18.6259C14.8944 18.7839 13.6342 18.7857 11.8605 18.7857H8.13953C6.36575 18.7857 5.10559 18.7839 4.14963 18.6259C3.21373 18.4714 2.67452 18.1815 2.28084 17.6978C1.88715 17.2142 1.65118 16.5517 1.52536 15.4019C1.39683 14.2274 1.39535 12.6792 1.39535 10.5C1.39535 8.3208 1.39683 6.77258 1.52536 5.59811C1.65118 4.4483 1.88715 3.78584 2.28084 3.30217Z"
        fill={color}
      />
      <path
        d="M5 10.5L8.75 14.25L15 6.75"
        stroke={color}
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Checkbox;
